const TEST_RESULT_REVIEWED_STATUSES = ['NOTIFY', 'SUBMIT', 'SUBMITTED', 'CLOSED'];

export { TEST_RESULT_REVIEWED_STATUSES };
